import cx from 'bem-classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {
  childrenUtils,
  createShorthandFactory,
  customPropTypes,
  getElementType,
  getUnhandledProps,
} from 'components/lib';

const TabPane = props => {
  const { children, className, content } = props;

  const classes = cx(
    { name: 'tab', modifiers: ['active', 'loading'] },
    props,
    className,
  );
  const rest = getUnhandledProps(TabPane, props);
  const ElementType = getElementType(TabPane, props);

  const calculatedDefaultProps = {};

  return (
    <ElementType {...calculatedDefaultProps} {...rest} className={classes}>
      {childrenUtils.isNil(children) ? content : children}
    </ElementType>
  );
};

TabPane.defaultProps = {
  active: true,
};

TabPane.propTypes = {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A tab pane can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A Tab.Pane can display a loading indicator. */
  loading: PropTypes.bool,
};

TabPane.handledProps = ['active', 'content', 'loading'];

TabPane.create = createShorthandFactory(TabPane, content => ({ content }));

export default TabPane;
